import { BaseNode } from '@antv/g6'

export class IndentedNode extends BaseNode {
  static defaultStyleProps = {
    ports: [
      {
        key: 'in',
        placement: 'right-bottom',
      },
      {
        key: 'out',
        placement: 'left-bottom',
      },
    ],
  }

  constructor(options) {
    Object.assign(options.style, IndentedNode.defaultStyleProps)
    super(options)
  }

  get childrenData() {
    return this.context.model.getChildrenData(this.id)
  }

  getKeyStyle(attributes) {
    const [width, height] = this.getSize(attributes)
    const keyStyle = super.getKeyStyle(attributes)
    return {
      width,
      height,
      ...keyStyle,
      fill: 'transparent',
    }
  }

  drawKeyShape(attributes, container) {
    const keyStyle = this.getKeyStyle(attributes)
    return this.upsert('key', 'rect', keyStyle, container)
  }

  getLabelStyle(attributes) {
    if (attributes.label === false || !attributes.labelText) return false
    return subStyleProps(this.getGraphicStyle(attributes), 'label')
  }

  drawIconArea(attributes, container) {
    const [, h] = this.getSize(attributes)
    const iconAreaStyle = {
      fill: 'transparent',
      height: 30,
      width: 12,
      x: -6,
      y: h,
      zIndex: -1,
    }
    this.upsert('icon-area', Rect, iconAreaStyle, container)
  }

  forwardEvent(target, type, listener) {
    if (target && !Reflect.has(target, '__bind__')) {
      Reflect.set(target, '__bind__', true)
      target.addEventListener(type, listener)
    }
  }

  getCountStyle(attributes) {
    const { collapsed, color } = attributes
    if (collapsed) {
      const [, height] = this.getSize(attributes)
      return {
        backgroundFill: color,
        cursor: 'pointer',
        fill: '#fff',
        fontSize: 8,
        padding: [0, 10],
        text: `${this.childrenData.length}`,
        textAlign: 'center',
        y: height + 8,
      }
    }

    return false
  }

  drawCountShape(attributes, container) {
    const countStyle = this.getCountStyle(attributes)
    const btn = this.upsert('count', Badge, countStyle, container)

    this.forwardEvent(btn, CommonEvent.CLICK, event => {
      event.stopPropagation()
      this.context.graph.emit(TreeEvent.COLLAPSE_EXPAND, {
        id: this.id,
        collapsed: false,
      })
    })
  }

  isShowCollapse(attributes) {
    return !attributes.collapsed && this.childrenData.length > 0
  }

  getCollapseStyle(attributes) {
    const { showIcon, color } = attributes
    if (!this.isShowCollapse(attributes)) return false
    const [, height] = this.getSize(attributes)
    return {
      visibility: showIcon ? 'visible' : 'hidden',
      backgroundFill: color,
      backgroundHeight: 12,
      backgroundWidth: 12,
      cursor: 'pointer',
      fill: '#fff',
      fontFamily: 'iconfont',
      fontSize: 8,
      text: '\ue6e4',
      textAlign: 'center',
      x: -1, // half of edge line width
      y: height + 8,
    }
  }

  drawCollapseShape(attributes, container) {
    const iconStyle = this.getCollapseStyle(attributes)
    const btn = this.upsert('collapse-expand', Badge, iconStyle, container)

    this.forwardEvent(btn, CommonEvent.CLICK, event => {
      event.stopPropagation()
      this.context.graph.emit(TreeEvent.COLLAPSE_EXPAND, {
        id: this.id,
        collapsed: !attributes.collapsed,
      })
    })
  }

  getAddStyle(attributes) {
    const { collapsed, showIcon } = attributes
    if (collapsed) return false
    const [, height] = this.getSize(attributes)
    const color = '#ddd'
    const lineWidth = 1

    return {
      visibility: showIcon ? 'visible' : 'hidden',
      backgroundFill: '#fff',
      backgroundHeight: 12,
      backgroundLineWidth: lineWidth,
      backgroundStroke: color,
      backgroundWidth: 12,
      cursor: 'pointer',
      fill: color,
      fontFamily: 'iconfont',
      text: '\ue664',
      textAlign: 'center',
      x: -1,
      y: height + (this.isShowCollapse(attributes) ? 22 : 8),
    }
  }

  drawAddShape(attributes, container) {
    const addStyle = this.getAddStyle(attributes)
    const btn = this.upsert('add', Badge, addStyle, container)

    this.forwardEvent(btn, CommonEvent.CLICK, event => {
      event.stopPropagation()
      this.context.graph.emit(TreeEvent.ADD_CHILD, { id: this.id })
    })
  }

  render(attributes = this.parsedAttributes, container = this) {
    super.render(attributes, container)

    this.drawCountShape(attributes, container)

    this.drawIconArea(attributes, container)
    this.drawCollapseShape(attributes, container)
    this.drawAddShape(attributes, container)
  }
}
